<template>
    <v-edit-dialog :return-value.sync="form.repliedAt" large cancel-text="취소" save-text="저장" v-on="{ save }" @open="sync">
        <slot />
        <template #input>
            <v-sheet width="240" class="mx-n3">
                <v-datetime-field v-model="form.repliedAt" hide-details clearable label="" />
            </v-sheet>
        </template>
    </v-edit-dialog>
</template>

<script>
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";

const initForm = (form = {}) => ({
    ...form,
    repliedAt: form.repliedAt || Date.now().toDateTime(),
});

export default {
    components: {
        VDatetimeField,
    },
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        form: initForm(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initForm(this.value);
        },
        save() {
            let { _id, repliedAt } = this.form;
            let form = { _id, repliedAt };

            this.$emit("update", form);
        },
    },
};
</script>

